var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ArrowLeft02Icon } from 'hugeicons-react';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ChatFeedback } from '../../../../application/common/constants/chat-feedback';
import { useLazyGetConversationQuery } from '../../../../application/features/chat/chat-api';
import { useLazyGetMachineDocumentListByIdsQuery } from '../../../../application/features/machine-documents/machine-document-api';
import useTranslate from '../../../../localization/helpers';
import usePersistCompany from '../../../hooks/usePersistCompany';
import ChatInfo from './tabs/feedback/chat-info';
import TrainingSegmentDetails from './tabs/feedback/segment-details';
var TrainingChatDetails = function () {
    var theme = useTheme();
    var translate = useTranslate().translate;
    var navigate = useNavigate();
    var _a = useParams(), conversationId = _a.conversationId, userId = _a.userId;
    usePersistCompany();
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var state = useLocation().state;
    var _b = __read(useState(), 2), activeMessage = _b[0], setActiveMessage = _b[1];
    var _c = __read(useLazyGetMachineDocumentListByIdsQuery(), 2), getConversationDocuments = _c[0], _d = _c[1].data, documents = _d === void 0 ? [] : _d;
    var _e = __read(useLazyGetConversationQuery(), 2), getConversation = _e[0], conversation = _e[1].data;
    var _f = conversation !== null && conversation !== void 0 ? conversation : {}, _g = _f.messages, messages = _g === void 0 ? [] : _g, _h = _f.document_list, document_list = _h === void 0 ? [] : _h;
    var isDislikedMessage = function (message) {
        return message.feedback === ChatFeedback.Disliked;
    };
    var feedbackMessages = useMemo(function () { return messages.filter(isDislikedMessage); }, [messages]);
    useEffect(function () {
        if (conversationId && userId)
            getConversation({ conversationId: conversationId, userId: userId });
    }, [conversationId, getConversation, userId]);
    useEffect(function () {
        if (document_list.length)
            getConversationDocuments({
                machineDocumentIds: document_list.map(function (d) { return d.document_id; })
            });
    }, [document_list, getConversationDocuments]);
    useEffect(function () {
        if (feedbackMessages.length && !activeMessage) {
            setActiveMessage(feedbackMessages[0]);
        }
    }, [feedbackMessages, activeMessage]);
    var handleBackClick = function () { return navigate(-1); };
    return (_jsxs(Box, { sx: {
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column'
        }, children: [!isscreen600900Landscape && (_jsxs(Box, { padding: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', children: [_jsx(IconButton, { color: 'primary', onClick: handleBackClick, children: _jsx(ArrowLeft02Icon, { size: 24 }) }), _jsx(Typography, { variant: 'h3', color: '#009983', children: translate('chat.chatDetails') })] })), _jsxs(Grid, { container: true, p: 2, paddingBottom: isscreen600900Landscape ? '0px' : isXs || isscreen600900 ? '100px' : 0, children: [_jsx(Grid, { size: { xs: 12, sm: isscreen600900 ? 12 : 6, md: 6 }, sx: {
                            display: 'flex',
                            height: isscreen600900Landscape
                                ? 'calc(100svh - 150px) '
                                : { md: 'calc(100svh - 250px)', xs: 'calc(100svh - 254px)' },
                            overflow: 'auto',
                            boxShadow: '0 10px 48px 0 #919EAB29',
                            position: 'relative',
                            overflowX: 'clip',
                            borderRadius: isXs || isscreen600900 ? '24px' : undefined
                        }, children: _jsx(ChatInfo, { activeMessage: activeMessage, setActiveMessage: setActiveMessage, messages: messages, documents: documents, conversationName: state === null || state === void 0 ? void 0 : state.conversationName }) }), !isXs && !isscreen600900 && (_jsx(Grid, { size: { xs: 12, sm: isscreen600900 ? 12 : 6, md: 6 }, sx: {
                            display: 'flex',
                            height: { md: 'calc(100svh - 250px)', xs: 'calc(100svh - 254px)' },
                            overflow: 'clip',
                            boxShadow: '0 10px 48px 0 #919EAB29',
                            position: 'relative'
                        }, children: _jsx(TrainingSegmentDetails, { activeMessage: activeMessage, setActiveMessage: setActiveMessage, messages: feedbackMessages }) }))] })] }));
};
export default TrainingChatDetails;
